import { useEffect } from 'react';
import { isAppModule } from '@src/utils/constants';
import useMetricsMeta from '@src/hooks/useMetricsMeta';

const useMetaEffects = ({ enabled }) => {
  const { forceUpdateUserDefinedMetricsMeta, forceUpdateFlowConfigMeta } = useMetricsMeta();

  useEffect(() => {
    if (enabled && isAppModule) {
      forceUpdateUserDefinedMetricsMeta();
      forceUpdateFlowConfigMeta();
    }
  }, [enabled]);
};

export default useMetaEffects;
